import { MdSupervisedUserCircle } from "react-icons/md";

// Admin Imports
import DashboardsDefault from "views/dashboards/default";
import DashboardsRTLDefault from "views/dashboards/rtl";
import DashboardsCarInterface from "views/dashboards/carInterface";
import DashboardsSmartHome from "views/dashboards/smartHome";

import SignInDefault from "views/auth/signIn/SignInDefault";
import ForgotPassword from "views/auth/forgotPassword/ForgotPasswordDefault";
import ResetPassword from "views/auth/forgotPassword/ResetPassword";
import Home from "views/home/Home";
import SignUpDefault from "views/auth/signUp/SignUpDefault";
import AccessCodePage from "views/auth/accessCode/AccessCodePage";
import FreelancePromo from "views/landing/FreelancePromo";
import TrackerDetail from "views/trackers/TrackerDetail";
import AdminSignals from "views/admin/signals/AdminSignals";
import AdminSignalForm from "views/admin/signals/AdminSignalForm";
import AdminCompanies from "views/admin/companies/AdminCompanies";
import AdminCompanyForm from "views/admin/companies/AdminCompanyForm";
import AdminCompanyDetail from "views/admin/companies/AdminCompanyDetail";
import BODashboard from "views/admin/bo/BODashboard";
import SearchLogs from "views/admin/bo/SearchLogs";
import UserActivity from "views/admin/bo/UserActivity";
import ImportEstablishmentsPeopleCsv from "views/admin/bo/ImportEstablishmentsPeopleCsv";
import ImportEtablissements from "views/admin/bo/ImportEtablissements";
import DuplicatePeople from "views/admin/bo/DuplicatePeople";
import GhostReview from "views/admin/bo/GhostReview";
import TodoTags from "views/admin/bo/TodoTags";
import BulkTag from "views/admin/bo/BulkTag";
import TodoFranchise from "views/admin/bo/TodoFranchise";
import WeirdNames from "views/admin/bo/WeirdNames";
import IdentityRepair from "views/admin/bo/IdentityRepair";
import FranchiseEventReview from "views/admin/bo/FranchiseEventReview";
import NewsArticles from "views/admin/bo/NewsArticles";
import CompanyOwnershipTree from "views/admin/bo/CompanyOwnershipTree";
import FounderEnrichment from "views/admin/bo/FounderEnrichment";
import PeopleManager from "views/admin/bo/PeopleManager";
import FranchiseList from "views/admin/bo/FranchiseList";
import FranchiseDetail from "views/admin/bo/FranchiseDetail";
import EstablishmentEnrichments from "views/admin/bo/EstablishmentEnrichments";
import StatusMonitoring from "views/admin/bo/StatusMonitoring";
import EnrichmentStatus from "views/admin/bo/EnrichmentStatus";
import AlimConfianceImport from "views/admin/bo/AlimConfianceImport";
import AdminSignalReports from "views/admin/bo/AdminSignalReports";
import ServicesMonitoring from "views/admin/bo/ServicesMonitoring";
import ZoneControl from "views/admin/bo/ZoneControl";
import ServiceDetail from "views/admin/bo/ServiceDetail";
import UnknownTags from "views/admin/bo/UnknownTags";
import BanishedTags from "views/admin/bo/BanishedTags";
import DatabaseStats from "views/admin/bo/DatabaseStats";
import EnrichmentKpis from "views/admin/bo/EnrichmentKpis";
import UnmatchedPlaces from "views/admin/bo/UnmatchedPlaces";
import ImportPlaces from "views/admin/bo/ImportPlaces";
import QueryLogs from "views/admin/bo/QueryLogs";
import CacheAdmin from "views/admin/bo/CacheAdmin";
import ApiKeys from "views/admin/bo/ApiKeys";
import AccessCodes from "views/admin/bo/AccessCodes";
import SupportTickets from "views/admin/bo/SupportTickets";
import HelpCenter from "views/admin/bo/HelpCenter";
import UsersHub from "views/admin/bo/UsersHub";
import Emailing from "views/admin/bo/Emailing";
import PublicApi from "views/admin/bo/PublicApi";
import PublicApiAccount from "views/admin/bo/PublicApiAccount";
import AiPrompts from "views/admin/bo/AiPrompts";
import ClientTypings from "views/admin/bo/ClientTypings";
import AutoApprove from "views/admin/bo/AutoApprove";
import BoddacHistory from "views/admin/bo/BoddacHistory";
import WeeklyMail from "views/admin/bo/WeeklyMail";
import NewsPage from "views/news/NewsPage";
import { Navigate } from "react-router-dom";
import CallList from "views/admin/bo-commercial/CallList";
import CommercialNews from "views/admin/bo-commercial/CommercialNews";
import {
    HomeIcon,
    ChatBubbleLeftEllipsisIcon,
    BeakerIcon,
    BuildingOffice2Icon,
    ViewColumnsIcon,
    BellAlertIcon,
    Cog6ToothIcon,
    GlobeAltIcon,
    ClockIcon,
    ChartBarIcon,
    SignalIcon,
    BuildingStorefrontIcon,
    FolderIcon,
    CheckBadgeIcon,
    ListBulletIcon,
    TagIcon,
    NewspaperIcon,
    ShieldCheckIcon,
} from "@heroicons/react/24/solid";
import { Zap, Layers, Mail, Users, UserSearch, PhoneCall } from "lucide-react";
import Community from "views/community";
import Pricing from "views/pricing";
import Account from "views/account";
// ...existing imports
import SettingsView from "views/settings/Settings";
import Success from "views/success";
import ConfirmPurchase from "views/confirmPurchase";
import ShareView from "views/share/Share";
import NotificationPage from "views/logs/Logs";
import AllLogs from "views/logs/AllLogs";
import Kanban from "views/kanban/Kanban";
import ComposeEmail from "views/email/ComposeEmail";
import EmailTemplates from "views/emailTemplates/EmailTemplates";
import EstablishmentDetail from "views/establishments/EstablishmentDetail";
import SirenEstablishments from "views/establishments/SirenEstablishments";
import AdminEmailSender from "views/admin/emails/AdminEmailSender";
import ScanCompany from "views/scan/ScanCompany";
import Signals from "views/signals/Signals";
import SignalFolderDetail from "views/signals/SignalFolderDetail";
import FounderSignals from "views/signals/FounderSignals";
import InstagramProspection from "views/instagram/InstagramProspection";
import EventAdminDashboard from "views/events/EventAdminDashboard";
import EnrichmentSuggestions from "views/admin/enrichments/EnrichmentSuggestions";
import ReviewedEnrichments from "views/admin/enrichments/ReviewedEnrichments";
import EventsMarketing from "views/events/EventsMarketing";
import CreateCompanySignalForm from "views/admin/CreateCompanySignalForm";
import Franchiseurs from "views/franchiseurs/Franchiseurs";
import FranchiseurDetail from "views/franchiseurs/FranchiseurDetail";
import MultiSiteOwnerDetail from "views/multiSite/MultiSiteOwnerDetail";
import RestaurantDatabase from "views/restaurant/RestaurantDatabase";
import RestaurantDetail from "views/restaurant/RestaurantDetail";
import AgentsPage from "views/agents/AgentsPage";
import ProspectionLists from "views/prospection/ProspectionLists";
import ProspectionView from "views/prospection/ProspectionView";
import DiscoverLists from "views/prospection/DiscoverLists";
import ClientTypes from "views/clientTypes/ClientTypes";
import LinkedinProspecting from "views/linkedin/LinkedinProspecting";
import NurturingList from "views/nurturings/NurturingList";
import NurturingDetail from "views/nurturings/NurturingDetail";
import CreateNurturingForm from "views/nurturings/CreateNurturingForm";
import ModernDashboard from "views/home/ModernDashboard";
import UseCases from "views/useCases/UseCases";
import { BsInstagram, BsLinkedin } from "react-icons/bs";

const routes = [
    // On menu
    {
        name: "Home",
        path: "/dashboard",
        layout: "",
        menu: true,
        icon: <HomeIcon className="text-inherit h-5 w-5" />,
        component: <ModernDashboard />,
    },
    // {
    //     name: "Dashboard",
    //     path: "/dashboard",
    //     layout: "",
    //     menu: true,
    //     icon: <HomeIcon className="text-inherit h-5 w-5" />,
    //     component: <Home />,
    // },
    // {
    //     name: "Ranking",
    //     path: "/ranking",
    //     layout: "",
    //     menu: true,
    //     icon: <ChartBarIcon className="text-inherit" />,
    //     component: <Ranking />,
    // }
    {
        name: "Notifications",
        path: "/notifications",
        layout: "",
        menu: false,
        icon: <BellAlertIcon className="text-inherit h-5 w-5" />,
        component: <NotificationPage />,
    },
    {
        name: "Compose Email",
        path: "/compose-email/:id",
        layout: "",
        menu: false,
        icon: <ChatBubbleLeftEllipsisIcon className="text-inherit" />,
        component: <ComposeEmail />,
    },
    {
        name: "Email Templates",
        path: "/email-templates",
        layout: "",
        menu: false,
        icon: <ChatBubbleLeftEllipsisIcon className="text-inherit h-5 w-5" />,
        component: <EmailTemplates />,
    },
    {
        name: "Community",
        path: "/community",
        layout: "",
        menu: false,
        icon: <BuildingOffice2Icon className="text-inherit h-5 w-5" />,
        component: <Community />,
    },
    {
        name: "Account",
        path: "/projects/:id",
        layout: "",
        menu: false,
        icon: <BuildingOffice2Icon className="text-inherit h-5 w-5" />,
        component: <Account />,
    },
    {
        name: "Mon compte",
        path: "/settings",
        layout: "",
        menu: false,
        icon: <Cog6ToothIcon className="text-inherit h-5 w-5" />,
        component: <SettingsView />,
    },
    {
        name: "Share",
        path: "/share",
        layout: "",
        menu: false,
        icon: <HomeIcon className="text-inherit h-5 w-5" />,
        component: <ShareView />,
    },
    {
        name: "Pricing",
        path: "/pricing",
        layout: "",
        menu: false,
        icon: <BuildingOffice2Icon className="text-inherit h-5 w-5" />,
        component: <Pricing />,
    },
    // {
    //     name: "Ranking",
    //     path: "/ranking",
    //     layout: "",
    //     menu: true,
    //     icon: <IoMdList className="text-inherit h-5 w-5" />,
    //     component: <Home />,
    // },
    // {
    //     name: "Lab",
    //     path: "/optimization",
    //     layout: "",
    //     menu: true,
    //     icon: <BeakerIcon className="text-inherit h-5 w-5" />,
    //     component: <Optimization />,
    // }
    {
        name: "Success",
        path: "/success",
        layout: "",
        menu: false,
        icon: <BeakerIcon className="text-inherit" />,
        component: <Success />,
    },
    {
        name: "Confirm Purchase",
        path: "/confirm-purchase",
        layout: "",
        menu: false,
        icon: <CheckBadgeIcon className="text-inherit" />,
        component: <ConfirmPurchase />,
    },
    {
        name: "Activités",
        path: "/activity",
        layout: "",
        menu: false,
        icon: <ClockIcon className="text-inherit h-5 w-5" />,
        component: <AllLogs />,
    },
    {
        name: "Network",
        path: "/network",
        layout: "",
        menu: false,
        icon: <GlobeAltIcon className="text-inherit h-5 w-5" />,
        component: <FreelancePromo />,
    },
    // {
    //     name: "Sourcing",
    //     path: "/sources",
    //     layout: "",
    //     menu: true,
    //     icon: <UserGroupIcon className="text-inherit h-5 w-5" />,
    //     component: <Source />,
    // }
    // {
    //     name: "Trackers",
    //     path: "/trackers",
    //     layout: "",
    //     menu: true,
    //     icon: <ChartBarIcon className="text-inherit h-5 w-5" />,
    //     component: <Trackers />,
    // },
    {
        name: "Tracker Detail",
        path: "/trackers/:id",
        layout: "",
        menu: false,
        icon: <ChartBarIcon className="text-inherit h-5 w-5" />,
        component: <TrackerDetail />,
    },
    {
        name: "Actualités",
        path: "/actualites",
        menuLabel: "Actus",
        layout: "",
        menu: true,
        menuSection: "Repérer" as const,
        icon: <NewspaperIcon className="text-inherit h-5 w-5" />,
        component: <NewsPage />,
    },
    {
        name: "Signaux",
        path: "/signals",
        layout: "",
        menu: true,
        menuSection: "Repérer" as const,
        icon: <SignalIcon className="text-inherit h-5 w-5" />,
        component: <Signals />,
    },
    {
        name: "Database",
        path: "/database",
        menuLabel: "Base",
        layout: "",
        menu: true,
        menuSection: "Repérer" as const,
        icon: <FolderIcon className="text-inherit h-5 w-5" />,
        component: <RestaurantDatabase />,
    },
    {
        name: "Mes listes",
        path: "/prospection",
        menuLabel: "Listes",
        layout: "",
        menu: true,
        menuSection: "Prospecter" as const,
        icon: <ListBulletIcon className="text-inherit h-5 w-5" />,
        component: <ProspectionLists />,
    },
    {
        name: "Prospection Detail",
        path: "/prospection/:id",
        layout: "",
        menu: false,
        icon: <CheckBadgeIcon className="text-inherit h-5 w-5" />,
        component: <ProspectionView />,
    },
    {
        name: "Découvrir des listes",
        path: "/prospection/discover",
        layout: "",
        menu: false,
        icon: <CheckBadgeIcon className="text-inherit h-5 w-5" />,
        component: <DiscoverLists />,
    },
    {
        name: "Intelligence clients",
        path: "/client-types",
        layout: "",
        // Off the menu, still reachable: the weekly brief and the prospection lists link here.
        menu: false,
        icon: <UserSearch className="text-inherit h-5 w-5" />,
        component: <ClientTypes />,
    },
    {
        name: "LinkedIn",
        path: "/prospection-linkedin",
        layout: "",
        menu: true,
        menuSection: "Prospecter" as const,
        icon: <BsLinkedin className="text-inherit h-5 w-5" />,
        component: <LinkedinProspecting />,
    },
    {
        name: "Franchiseurs",
        path: "/franchiseurs",
        menuLabel: "Franchis.",
        layout: "",
        menu: true,
        menuSection: "Repérer" as const,
        icon: <BuildingStorefrontIcon className="text-inherit h-5 w-5" />,
        component: <Franchiseurs />,
    },
    {
        name: "Franchiseur Detail",
        path: "/franchiseurs/:id",
        layout: "",
        menu: false,
        icon: <BuildingStorefrontIcon className="text-inherit h-5 w-5" />,
        component: <FranchiseurDetail />,
    },
    {
        name: "Multi-sites",
        path: "/multi-site",
        layout: "",
        menu: false,
        icon: <BsInstagram className="text-inherit h-4 w-4" />,
        component: <InstagramProspection />,
    },
    {
        name: "Multi-site Detail",
        path: "/multi-site/:id",
        layout: "",
        menu: false,
        icon: <BuildingOffice2Icon className="text-inherit h-5 w-5" />,
        component: <MultiSiteOwnerDetail />,
    },
    {
        name: "Nurturing",
        path: "/nurturings",
        layout: "",
        menu: false,
        icon: <ClockIcon className="text-inherit h-5 w-5" />,
        component: <NurturingList />,
    },
    {
        name: "Créer un nurturing",
        path: "/nurturings/create",
        layout: "",
        menu: false,
        icon: <ClockIcon className="text-inherit h-5 w-5" />,
        component: <CreateNurturingForm />,
    },
    {
        name: "Éditer un nurturing",
        path: "/nurturings/:id/edit",
        layout: "",
        menu: false,
        icon: <ClockIcon className="text-inherit h-5 w-5" />,
        component: <CreateNurturingForm />,
    },
    {
        name: "Nurturing Detail",
        path: "/nurturings/:id",
        layout: "",
        menu: false,
        icon: <ClockIcon className="text-inherit h-5 w-5" />,
        component: <NurturingDetail />,
    },
    {
        name: "Cas d'usage",
        path: "/use-cases",
        layout: "",
        menu: false,
        icon: <Layers className="text-inherit h-5 w-5" />,
        component: <UseCases />,
    },
    {
        name: "CRM",
        path: "/kanban",
        layout: "",
        menu: true,
        menuSection: "Suivre" as const,
        icon: <ViewColumnsIcon className="text-inherit h-5 w-5" />,
        component: <Kanban />,
    },
    {
        name: "Restaurant Detail",
        path: "/restaurants/:id",
        layout: "",
        menu: false,
        icon: <BuildingStorefrontIcon className="text-inherit h-5 w-5" />,
        component: <RestaurantDetail />,
    },
    // Admin-only menu item
    {
        name: "Backoffice",
        path: "/bo",
        layout: "",
        menu: true,
        adminOnly: true,
        icon: <Cog6ToothIcon className="text-inherit h-5 w-5" />,
        component: <BODashboard />,
    },
    // Admin-only menu item — the sales back-office: the week's calling list and news moderation
    {
        name: "Backoffice commercial",
        path: "/bo-commercial",
        layout: "",
        menu: true,
        adminOnly: true,
        icon: <PhoneCall className="text-inherit h-5 w-5" />,
        component: <CallList />,
    },
    {
        name: "Backoffice commercial - Actualités",
        path: "/bo-commercial/news",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <NewspaperIcon className="text-inherit h-5 w-5" />,
        component: <CommercialNews />,
    },
    {
        name: "Admin - Signals",
        path: "/bo/signals",
        layout: "",
        menu: false,
        icon: <SignalIcon className="text-inherit h-5 w-5" />,
        component: <AdminSignals />,
    },
    {
        name: "Admin - Companies",
        path: "/bo/companies",
        layout: "",
        menu: false,
        icon: <BuildingOffice2Icon className="text-inherit h-5 w-5" />,
        component: <AdminCompanies />,
    },
    {
        name: "Admin - Search Logs",
        path: "/bo/search-logs",
        layout: "",
        menu: false,
        icon: <ChartBarIcon className="text-inherit h-5 w-5" />,
        component: <SearchLogs />,
    },
    {
        name: "Admin - User Activity",
        path: "/bo/activity",
        layout: "",
        menu: false,
        icon: <ChartBarIcon className="text-inherit h-5 w-5" />,
        component: <UserActivity />,
    },
    {
        name: "Admin - Email Sender",
        path: "/bo/emails",
        layout: "",
        menu: false,
        icon: <ChatBubbleLeftEllipsisIcon className="text-inherit h-5 w-5" />,
        component: <AdminEmailSender />,
    },
    {
        name: "Admin - Enrichments",
        path: "/bo/enrichments",
        layout: "",
        menu: false,
        icon: <ChartBarIcon className="text-inherit h-5 w-5" />,
        component: <EnrichmentSuggestions />,
    },
    {
        name: "Admin - Reviewed Enrichments",
        path: "/bo/enrichments/reviewed",
        layout: "",
        menu: false,
        icon: <CheckBadgeIcon className="text-inherit h-5 w-5" />,
        component: <ReviewedEnrichments />,
    },
    {
        name: "Admin - Events",
        path: "/bo/events",
        layout: "",
        menu: false,
        icon: <ChartBarIcon className="text-inherit h-5 w-5" />,
        component: <EventAdminDashboard />,
    },
    {
        name: "Admin - Import CSV",
        path: "/bo/import-csv",
        layout: "",
        menu: false,
        icon: <ChartBarIcon className="text-inherit h-5 w-5" />,
        component: <ImportEstablishmentsPeopleCsv />,
    },
    {
        name: "Admin - Doublons dirigeants",
        path: "/bo/duplicate-people",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <CheckBadgeIcon className="text-inherit h-5 w-5" />,
        component: <DuplicatePeople />,
    },
    {
        name: "Admin - Import Établissements",
        path: "/bo/import-etablissements",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <BuildingStorefrontIcon className="text-inherit h-5 w-5" />,
        component: <ImportEtablissements />,
    },
    {
        name: "Admin - Fantômes",
        path: "/bo/ghosts",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <BuildingStorefrontIcon className="text-inherit h-5 w-5" />,
        component: <GhostReview />,
    },
    {
        name: "Admin - Todo Tags",
        path: "/bo/todo-tags",
        layout: "",
        menu: false,
        icon: <TagIcon className="text-inherit h-5 w-5" />,
        component: <TodoTags />,
    },
    {
        name: "Admin - Bulk Tag",
        path: "/bo/bulk-tags",
        layout: "",
        menu: false,
        icon: <TagIcon className="text-inherit h-5 w-5" />,
        component: <BulkTag />,
    },
    {
        name: "Admin - Todo Franchise",
        path: "/bo/todo-franchise",
        layout: "",
        menu: false,
        icon: <BuildingStorefrontIcon className="text-inherit h-5 w-5" />,
        component: <TodoFranchise />,
    },
    {
        name: "Admin - Noms bizarres",
        path: "/bo/weird-names",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <TagIcon className="text-inherit h-5 w-5" />,
        component: <WeirdNames />,
    },
    {
        name: "Admin - Identité dirigeants",
        path: "/bo/identity-repair",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <TagIcon className="text-inherit h-5 w-5" />,
        component: <IdentityRepair />,
    },
    {
        name: "Admin - Franchise Review",
        path: "/bo/franchise-review",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <BuildingStorefrontIcon className="text-inherit h-5 w-5" />,
        component: <FranchiseEventReview />,
    },
    {
        name: "Admin - Ownership Tree",
        path: "/bo/ownership-tree",
        layout: "",
        menu: false,
        icon: <BuildingOffice2Icon className="text-inherit h-5 w-5" />,
        component: <CompanyOwnershipTree />,
    },
    {
        name: "Admin - Founder Enrichment",
        path: "/bo/founder-enrichment",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <BuildingOffice2Icon className="text-inherit h-5 w-5" />,
        component: <FounderEnrichment />,
    },
    {
        name: "Admin - Personnes",
        path: "/bo/people",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <BuildingOffice2Icon className="text-inherit h-5 w-5" />,
        component: <PeopleManager />,
    },
    {
        name: "Admin - Franchises",
        path: "/bo/franchises",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <BuildingStorefrontIcon className="text-inherit h-5 w-5" />,
        component: <FranchiseList />,
    },
    {
        name: "Admin - Franchise Detail",
        path: "/bo/franchises/:id",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <BuildingStorefrontIcon className="text-inherit h-5 w-5" />,
        component: <FranchiseDetail />,
    },
    {
        name: "Admin - Enrichissements établissement",
        path: "/bo/establishments/:id",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <BuildingStorefrontIcon className="text-inherit h-5 w-5" />,
        component: <EstablishmentEnrichments />,
    },
    {
        name: "Admin - Status Monitoring",
        path: "/bo/status-monitoring",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <ChartBarIcon className="text-inherit h-5 w-5" />,
        component: <StatusMonitoring />,
    },
    {
        name: "Admin - Enrichment Status",
        path: "/bo/enrichment-status",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <ChartBarIcon className="text-inherit h-5 w-5" />,
        component: <EnrichmentStatus />,
    },
    {
        name: "Admin - AlimConfiance",
        path: "/bo/alim-confiance",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <ShieldCheckIcon className="text-inherit h-5 w-5" />,
        component: <AlimConfianceImport />,
    },
    {
        name: "Admin - Signal Reports",
        path: "/bo/signal-reports",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <ShieldCheckIcon className="text-inherit h-5 w-5" />,
        component: <AdminSignalReports />,
    },
    {
        name: "Admin - Services",
        path: "/bo/services",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <ShieldCheckIcon className="text-inherit h-5 w-5" />,
        component: <ServicesMonitoring />,
    },
    {
        name: "Admin - Zone",
        path: "/bo/zone",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <ShieldCheckIcon className="text-inherit h-5 w-5" />,
        component: <ZoneControl />,
    },
    {
        name: "Admin - Service Detail",
        path: "/bo/services/:type",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <ShieldCheckIcon className="text-inherit h-5 w-5" />,
        component: <ServiceDetail />,
    },
    {
        name: "Admin - News Articles",
        path: "/bo/news-articles",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <NewspaperIcon className="text-inherit h-5 w-5" />,
        component: <NewsArticles />,
    },
    {
        name: "Admin - Tags inconnus",
        path: "/bo/unknown-tags",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <TagIcon className="text-inherit h-5 w-5" />,
        component: <UnknownTags />,
    },
    {
        name: "Admin - Tags bannis",
        path: "/bo/banished-tags",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <TagIcon className="text-inherit h-5 w-5" />,
        component: <BanishedTags />,
    },
    {
        name: "Admin - KPI",
        path: "/bo/db-stats",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <ChartBarIcon className="text-inherit h-5 w-5" />,
        component: <DatabaseStats />,
    },
    {
        name: "Admin - KPI enrichissements",
        path: "/bo/enrichment-kpis",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <ChartBarIcon className="text-inherit h-5 w-5" />,
        component: <EnrichmentKpis />,
    },
    {
        name: "Admin - Lieux non reliés",
        path: "/bo/unmatched-places",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <ChartBarIcon className="text-inherit h-5 w-5" />,
        component: <UnmatchedPlaces />,
    },
    {
        name: "Admin - Import des lieux",
        path: "/bo/import-lieux",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <ChartBarIcon className="text-inherit h-5 w-5" />,
        component: <ImportPlaces />,
    },
    {
        name: "Admin - Query Logs",
        path: "/bo/query-logs",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <ChartBarIcon className="text-inherit h-5 w-5" />,
        component: <QueryLogs />,
    },
    {
        name: "Admin - Cache",
        path: "/bo/cache",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <ChartBarIcon className="text-inherit h-5 w-5" />,
        component: <CacheAdmin />,
    },
    {
        name: "Admin - API Keys",
        path: "/bo/api-keys",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <ChartBarIcon className="text-inherit h-5 w-5" />,
        component: <ApiKeys />,
    },
    {
        name: "Admin - Utilisateurs",
        path: "/bo/users",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <ChartBarIcon className="text-inherit h-5 w-5" />,
        component: <UsersHub />,
    },
    {
        name: "Admin - Emails clients",
        path: "/bo/emailing",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <ChartBarIcon className="text-inherit h-5 w-5" />,
        component: <Emailing />,
    },
    {
        name: "Admin - Support",
        path: "/bo/support",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <ChartBarIcon className="text-inherit h-5 w-5" />,
        component: <SupportTickets />,
    },
    {
        name: "Admin - Centre d'aide",
        path: "/bo/help-center",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <ChartBarIcon className="text-inherit h-5 w-5" />,
        component: <HelpCenter />,
    },
    {
        name: "Admin - Codes d'accès",
        path: "/bo/access-codes",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <ChartBarIcon className="text-inherit h-5 w-5" />,
        component: <AccessCodes />,
    },
    {
        name: "Admin - API publique",
        path: "/bo/public-api",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <ChartBarIcon className="text-inherit h-5 w-5" />,
        component: <PublicApi />,
    },
    {
        name: "Admin - API publique client",
        path: "/bo/public-api/:userId",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <ChartBarIcon className="text-inherit h-5 w-5" />,
        component: <PublicApiAccount />,
    },
    {
        name: "Admin - Prompts IA",
        path: "/bo/ai-prompts",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <ChartBarIcon className="text-inherit h-5 w-5" />,
        component: <AiPrompts />,
    },
    {
        name: "Admin - Typologies clients",
        path: "/bo/client-typings",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <Users className="text-inherit h-5 w-5" />,
        component: <ClientTypings />,
    },
    {
        name: "Admin - Auto-Approve",
        path: "/bo/auto-approve",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <Zap className="text-inherit h-5 w-5" />,
        component: <AutoApprove />,
    },
    {
        name: "Admin - BODACC History",
        path: "/bo/boddac-history",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <Layers className="text-inherit h-5 w-5" />,
        component: <BoddacHistory />,
    },
    {
        name: "Admin - Mail hebdomadaire",
        path: "/bo/weekly-mail",
        layout: "",
        menu: false,
        adminOnly: true,
        icon: <Mail className="text-inherit h-5 w-5" />,
        component: <WeeklyMail />,
    },
    {
        name: "Agents IA",
        path: "/agents",
        layout: "",
        menu: false,
        icon: <Zap className="text-inherit h-5 w-5" />,
        component: <AgentsPage />,
    },
    {
        name: "Actualités (ancienne adresse)",
        path: "/restaurant-news",
        layout: "",
        menu: false,
        icon: <NewspaperIcon className="text-inherit h-5 w-5" />,
        // Old page, replaced by /actualites; kept as a redirect for saved links.
        component: <Navigate to="/actualites" replace />,
    },
    {
        name: "Market Insights",
        path: "/events/marketing",
        layout: "",
        menu: false,
        icon: <ChartBarIcon className="text-inherit h-5 w-5" />,
        component: <EventsMarketing />,
    },
    {
        name: "Signal Folder",
        path: "/signals/folder/:folderId",
        layout: "",
        menu: false,
        icon: <SignalIcon className="text-inherit h-5 w-5" />,
        component: <SignalFolderDetail />,
    },
    {
        name: "Scanner",
        path: "/scanner",
        layout: "",
        menu: false,
        icon: <BeakerIcon className="text-inherit h-5 w-5" />,
        component: <ScanCompany />,
    },
    {
        name: "Scanner Company",
        path: "/scanner/:query",
        layout: "",
        menu: false,
        icon: <BeakerIcon className="text-inherit h-5 w-5" />,
        component: <ScanCompany />,
    },
    {
        name: "Établissement",
        path: "/establishments/:id",
        layout: "",
        menu: false,
        icon: <BuildingStorefrontIcon className="text-inherit h-5 w-5" />,
        component: <EstablishmentDetail />,
    },
    {
        name: "Établissements par SIREN",
        path: "/siren/:siren",
        layout: "",
        menu: false,
        icon: <BuildingStorefrontIcon className="text-inherit h-5 w-5" />,
        component: <SirenEstablishments />,
    },
    {
        name: "Founder Signals",
        path: "/signals/founder",
        layout: "",
        menu: false,
        icon: <SignalIcon className="text-inherit h-5 w-5" />,
        component: <FounderSignals />,
    },
    {
        name: "Admin - Create Signal",
        path: "/bo/signals/create",
        layout: "",
        menu: false,
        icon: <SignalIcon className="text-inherit h-5 w-5" />,
        component: <AdminSignalForm />,
    },
    {
        name: "Admin - Edit Signal",
        path: "/bo/signals/edit/:id",
        layout: "",
        menu: false,
        icon: <SignalIcon className="text-inherit h-5 w-5" />,
        component: <AdminSignalForm />,
    },
    {
        name: "Admin - Create Company",
        path: "/bo/companies/create",
        layout: "",
        menu: false,
        icon: <BuildingOffice2Icon className="text-inherit h-5 w-5" />,
        component: <AdminCompanyForm />,
    },
    {
        name: "Admin - Edit Company",
        path: "/bo/companies/edit/:id",
        layout: "",
        menu: false,
        icon: <BuildingOffice2Icon className="text-inherit h-5 w-5" />,
        component: <AdminCompanyForm />,
    },
    {
        name: "Admin - Company Detail",
        path: "/bo/companies/:id",
        layout: "",
        menu: false,
        icon: <BuildingOffice2Icon className="text-inherit h-5 w-5" />,
        component: <AdminCompanyDetail />,
    },
    // --- Auth ---
    {
        name: "Default",
        menu: false,
        layout: "/auth",
        path: "/login",
        component: <SignInDefault />,
    },
    // register
    {
        name: "Default",
        menu: false,
        layout: "/auth",
        path: "/register",
        component: <SignUpDefault />,
    },
    {
        name: "Default",
        menu: false,
        layout: "/auth",
        path: "/access-code",
        component: <AccessCodePage />,
    },
    {
        name: "Default",
        menu: false,
        layout: "/auth",
        path: "/forgot-password",
        component: <ForgotPassword />,
    },
    {
        name: "Default",
        menu: false,
        layout: "/auth",
        path: "/reset-password/:id",
        component: <ResetPassword />,
    },
    {
        name: "Administration",
        path: "/dashboards",
        icon: <MdSupervisedUserCircle className="text-inherit h-5 w-5" />,
        collapse: true,
        menu: false,
        items: [
            {
                name: "Main Dashboard",
                layout: "/admin",
                path: "/dashboards/default",
                component: <DashboardsDefault />,
            },
            {
                name: "Car Interface",
                layout: "/admin",
                path: "/dashboards/car-interface",
                component: <DashboardsCarInterface />,
            },
            {
                name: "Smart Home",
                layout: "/admin",
                path: "/dashboards/smart-home",
                component: <DashboardsSmartHome />,
            },
            {
                name: "RTL",
                layout: "/rtl",
                path: "/dashboards/rtl",
                component: <DashboardsRTLDefault />,
            },
        ],
    },
    {
        name: "Admin - Create Company & Signal",
        path: "/bo/create-company-signal",
        layout: "",
        menu: false,
        icon: <BuildingOffice2Icon className="text-inherit h-5 w-5" />,
        component: <CreateCompanySignalForm />,
    },
];
export default routes;
